import React, { createContext, useContext, useState } from 'react';

const TitleContext = createContext({ setTitle: () => { }, title: '' });

export const TitleProvider = ({ children }) => {
    const [title, setTitle] = useState('Dashboard');
    return (
        <TitleContext.Provider value={{ title, setTitle }}>
            {children}
        </TitleContext.Provider>
    );
};

export const useTitle = () => {
    const ctx = useContext(TitleContext);
    if (!ctx) throw new Error('useTitle must be used within a TitleProvider');
    return ctx;
}; 